module.exports = __webpack_public_path__ + "static/img/2212@3x.2a984bf9.png";